'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const scrollIntoView = require('scroll-into-view');
const windowCheck = require('bunsen/helpers/windowCheck');
const tokenReplace = require('dibs-token-replace');
const ContextComponent = require('../../../global/components/ContextComponent');
const SanitizeHtml = require('../../../global/components/SanitizeHtml');
const {
    trackSimilarItemsDisplayed,
    trackSimilarItemClick,
    trackSimilarViewAllClick } = require('../../actions/pdpTrackingActions');

const CarouselItem = require('../Carousel/CarouselItem');
const SPACE = ' ';

function SimilarHeader({copy, title, itemIsUnavailable}) {
    if (itemIsUnavailable) {
        return <h3 className="pdp-similar-header-title">{copy.soldSubheader}</h3>;
    }

    return (
        <h2 className="pdp-similar-header-title">
            {copy.header}{SPACE}
            <span className="pdp-similar-header-info">{title}</span>
        </h2>
    );
}

SimilarHeader.propTypes = {
    copy: PropTypes.object,
    title: PropTypes.string,
    itemIsUnavailable: PropTypes.bool
};

function SoldHeader({copy, title}) {
    const soldCopy = copy.soldHeader;
    const allowedTags = ['i'];
    const soldHeader = tokenReplace(soldCopy, {
        itemTitle: title
    });

    return (
        <h2 className="pdp-similar-header-module">
            <SanitizeHtml allowedTags={allowedTags} content={soldHeader} />
        </h2>
    );
}

SoldHeader.propTypes = {
    copy: PropTypes.object,
    title: PropTypes.string
};


function SimilarItem({item, onClick, index}) {
    return (
        <div className="colLg2 colMd4 colXs6 pdp-similar-item-wrapper">
            <div className="pdp-similar-item">
                <a href={item.uri} className="pdp-similar-item-link" onClick={onClick}>
                    <CarouselItem className="pdp-similar-item-image"
                        title={item.title}
                        src={item.image}
                        index={index + 1}
                    />
                    <span className="pdp-similar-item-text">{item.title}</span>
                </a>
            </div>
        </div>
    );
}

SimilarItem.propTypes = {
    index: PropTypes.number,
    item: PropTypes.object,
    onClick: PropTypes.func
};

function SimilarItems({items, onClick}) {
    if (!items.length) {
        return null;
    }

    return (
        <div>
            {items.map((recommendations, recIndex) => {
                return (
                    <div className="rowFlex pdp-similar-items" key={`similar-${recIndex}`}>
                        {recommendations.map((item, index) => {
                            return <SimilarItem item={item} onClick={onClick} key={item.id} index={index} />;
                        })}
                    </div>
                );
            })}
        </div>
    );
}

SimilarItems.propTypes = {
    items: PropTypes.array,
    onClick: PropTypes.func
};

class Similar extends ContextComponent {

    constructor(props) {
        super(props);

        this._handleClick = this._handleClick.bind(this);
        this._onSimilarCtaClick = this._onSimilarCtaClick.bind(this);
    }

    componentDidMount() {
        this.context.executeAction(trackSimilarItemsDisplayed);
    }

    _handleClick() {
        this.context.executeAction(trackSimilarItemClick);
    }

    _onSimilarCtaClick(event) {
        const gridHeader = windowCheck.document.querySelector('.pdp-suggestion-grid-header');

        event.preventDefault();
        this.context.executeAction(trackSimilarViewAllClick);
        scrollIntoView(gridHeader, {time: 1000, align: { top: 0.1 }});
    }

    render() {
        const {copy, title, items, itemIsUnavailable} = this.props;

        return (
            <div className="pdp-similar">
                <div className="pdp-similar-inner">
                    {itemIsUnavailable && <SoldHeader copy={copy.similar} title={title} />}
                    <div className="pdp-similar-header">
                        <SimilarHeader copy={copy.similar} title={title} itemIsUnavailable={itemIsUnavailable} />
                        <a href="#0" className="pdp-similar-cta" onClick={this._onSimilarCtaClick}>
                            {copy.similar.cta}
                        </a>
                    </div>
                    <SimilarItems items={items} onClick={this._handleClick} />
                </div>
            </div>
        );
    }
}

Similar.propTypes = {
    items: PropTypes.array,
    itemIsUnavailable: PropTypes.bool,
    copy: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired
};

Similar.defaultProps = {
    items: []
};

module.exports = Similar;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Similar/Similar.jsx